var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 9 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.03.297c-.679 0-1.228.542-1.228 1.21v6.065c0 .668.55 1.21 1.227 1.21.678 0 1.228-.542 1.228-1.21V1.507c0-.668-.55-1.21-1.228-1.21M1.599.297C.92.297.37.84.37 1.507v6.065c0 .668.55 1.21 1.228 1.21s1.227-.542 1.227-1.21V1.507c0-.668-.55-1.21-1.227-1.21"
  })));
};
export default SvgPause;